import { computed } from '@angular/core';
import { IOpportunityConfig, IOpportunityData, IOpportunityModel } from '@business/api';
// import { OpportunityService } from '@business/kernel';
import { TOptional } from '@business/types';
import { isNotEmpty } from '@business/utils';
import { signalStore, signalStoreFeature, withComputed, withMethods } from '@ngrx/signals';
import { withDomainState } from '../../common';
import { defaultDomainState, defaultDomainStateConfig } from '../../functions';
import { IDomainState, IStateConfig } from '../../model';

export interface IOpportunityState extends IDomainState<IOpportunityModel, IOpportunityData, IOpportunityConfig> {}

const initialOpportunityState: IOpportunityState = defaultDomainState();
const opportunityStateConfig: IStateConfig = defaultDomainStateConfig({ storeIdentifier: 'opportunity' });

export const OpportunityStore = signalStore({ providedIn: 'root' }, withBaseOpportunityStore(initialOpportunityState, opportunityStateConfig));

function withBaseOpportunityStore(initialState: IOpportunityState, stateConfig: IStateConfig) {
  return signalStoreFeature(
    withDomainState<IOpportunityModel, IOpportunityData, IOpportunityConfig>(initialState, stateConfig),
    withComputed((store) => ({
      opportunityCreated: computed<TOptional<boolean>>(() => {
        const model = store.selectModel();
        return isNotEmpty(model?.opportunityCreated);
      })
    })),
    withMethods((store) => ({
      terminateOpportunity() {
        // opportunityStore will be cleaned up
      }
    }))
  );
}
